import React from 'react';
import dayjs from 'dayjs';

import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { StyledIconButton } from 'components/shared/MuiExtensions';
import Zone from 'components/shared/Zone';
import { formatTimezone } from 'utils/functions';
import { DayHours } from 'typings';

interface BusinessHoursProps {
  hours: DayHours[];
  timezone: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    hours: {
      padding: theme.spacing(0, 1),
    },
  })
);

const BusinessHours = ({ hours, timezone }: BusinessHoursProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const formattedHours = hours.map((day: DayHours, index: number) => {
    const formattedIntervals = day.intervals.length
      ? day.intervals
          .map(
            (interval) =>
              `${dayjs(interval.from, 'HH:mm').format('h:mm A')} - ` +
              `${dayjs(interval.to, 'HH:mm').format('h:mm A')}`
          )
          .join(', ')
      : 'closed';

    return { day: day.day, hours: formattedIntervals };
  });

  const businessHours = formattedHours?.map((day: any) => {
    return (
      <div key={`bh-${day.day}`} className="horizontal-space">
        <Typography variant="subtitle1" className={classes.hours}>
          {day.day}
        </Typography>
        <Typography variant="body2" className={classes.hours}>
          {day.hours}
        </Typography>
      </div>
    );
  });

  return (
    <div>
      <StyledIconButton
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        color="inherit"
      >
        <AccessTimeIcon />
      </StyledIconButton>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Zone
          heading={
            <div className="horizontal-space">
              business hours
              {!!timezone && <span>{formatTimezone(timezone)}</span>}
            </div>
          }
        >
          {businessHours}
        </Zone>
      </Popover>
    </div>
  );
};

export default BusinessHours;
